import { render, staticRenderFns } from "./DetailSlitCoil.vue?vue&type=template&id=0a3687ac&scoped=true&"
import script from "./DetailSlitCoil.vue?vue&type=script&lang=js&"
export * from "./DetailSlitCoil.vue?vue&type=script&lang=js&"
import style0 from "./DetailSlitCoil.vue?vue&type=style&index=0&id=0a3687ac&lang=scss&scoped=true&"
import style1 from "./DetailSlitCoil.vue?vue&type=style&index=1&id=0a3687ac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a3687ac",
  null
  
)

export default component.exports